import React from 'react';
import Table, { TableBody } from '@ingka/table';
import GridTableHeader from './table-header/GridTableHeader';
import NoDataRow from './table-body/NoDataRow';
import DataRows from './table-body/DataRows';
import GroupedRows from './table-body/GroupedRows';
import LoadingTriggerRow from './table-body/LoadingTriggerRow';
import { ColumnDefinition, SortModel } from 'features/gridReport/models';

interface GridReportTableBodyProps {
  columns: ColumnDefinition[];
  sortModel: SortModel[];
  toggleSort: (field: string, shiftKey: boolean) => void;
  data: any[];
  loadingTriggerRef: React.RefObject<HTMLTableRowElement>;
  hasMoreData: boolean;
  loadingMore: boolean;
  rowGroupFields: string[];
}

export const GridReportTableBody: React.FC<GridReportTableBodyProps> = ({
  columns,
  sortModel,
  toggleSort,
  data,
  loadingTriggerRef,
  hasMoreData,
  loadingMore,
  rowGroupFields,
}) => {
  // Grouped fields move into each group's header row instead of repeating per row.
  const isGroupColumn = (column: ColumnDefinition) =>
    rowGroupFields.includes(String(column.field));
  const groupColumns = columns.filter(isGroupColumn);
  const tableColumns = columns.filter(column => !isGroupColumn(column));
  const visibleColumnCount = Math.max(
    tableColumns.filter(col => col.show !== false).length,
    1
  );

  return (
    <div className={`table-container`}>
      <Table fullWidth>
        <GridTableHeader
          columns={tableColumns}
          sortModel={sortModel}
          onToggleSort={toggleSort}
        />
        <TableBody striped={groupColumns.length === 0}>
          {data.length === 0 ? (
            <NoDataRow colSpan={visibleColumnCount} />
          ) : (
            <>
              {groupColumns.length > 0 ? (
                <GroupedRows data={data} columns={tableColumns} groupColumns={groupColumns} />
              ) : (
                <DataRows data={data} columns={tableColumns} />
              )}
              <LoadingTriggerRow
                ref={loadingTriggerRef}
                colSpan={visibleColumnCount}
                hasMoreData={hasMoreData}
                loadingMore={loadingMore}
              />
            </>
          )}
        </TableBody>
      </Table>
    </div>
  );
};
